<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1 v-if="form.id">{{ $t('common.change')}}</h1>
      <h1 v-else>{{ $t('kiosk.new_kiosk')}}</h1>
    </div>
    <div class="details-component__content">
      <form class="form">
        <fieldset class="form__fieldset" style="margin-top: 50px">
            <div class="form__field" :class="{'form__field_error' : errors.has('product')}">
                <label for="product" class="form__label">{{ $t('common.product') }}</label>
                <el-select name="product"
                  v-model="productId"
                  placeholder=""
                  v-validate="'required'">
                  <el-option
                    v-for="product in products.items"
                    :label="product.name"
                    :value="product.id"
                    :key="product.id">
                  </el-option>
                </el-select>
                <tooltip v-show="errors.has('product')" class="form__validation">{{ $t('errors.product_field_required') }}</tooltip>
            </div>
            <div class="form__field">
                <label for="description" class="form__label">{{ $t('kiosk.description')}}</label>
                <input type="text" class="form__input" v-model.trim="form.description" id="description" data-vv-as="description" name="description"  />
            </div>
            <div v-if="isSuperAdmin() || isLandlord()" class="form__field">
              <label for="pin" class="form__label">{{ $t('kiosk.pin')}}</label>
              <input type="text" class="form__input" v-model.trim="form.pin" id="pin" data-vv-as="pin" name="pin" v-validate="{ rules: { regex: /^[A-Z0-9]+$/} }" />
              <tooltip v-show="errors.has('pin')" class="form__validation">{{ $t('errors.invalid_pin_field') }}</tooltip>
            </div>
          <div v-if="isLandlord()" class="form__field">
            <label for="pos_id" class="form__label">POS terminal ID</label>
            <input type="text" class="form__input" v-model.trim="form.pos_id" id="pos_id" data-vv-as="pos_id" name="pos_id" />
          </div>
          <div v-if="terminals.length > 1" class="form__field" :class="{'form__field_error' : errors.has('terminal')}">
            <label for="terminal" class="form__label">{{ $t('common.terminal') }}</label>
            <el-select name="terminal"
                       v-model="form.terminal_provider"
                       placeholder="">
              <el-option
                v-for="terminal in terminals"
                :label="terminal"
                :value="terminal"
                :key="terminal">
              </el-option>
            </el-select>
            <tooltip v-show="errors.has('product')" class="form__validation">{{ $t('errors.product_field_required') }}</tooltip>
          </div>
            <div v-if="isLandlord()" class="form__field">
                <label for="hash" class="form__label">{{ $t('kiosk.hash')}}</label>
                <input type="text" class="form__input" v-model.trim="form.kiosk_hash" id="hash" data-vv-as="hash" name="hash" v-validate="'min:20, max:50'" />
                <tooltip v-show="errors.has('hash')" class="form__validation">{{ $t('errors.invalid_hash_field') }}</tooltip>
            </div>
            <div v-if="isLandlord()" class="form__field">
                <label for="hash_enabled" class="form__label">{{ $t('kiosk.hashEnabled')}}</label>
                <input style="height: 20px" type="checkbox" v-model.trim="form.hash_enabled" id="hash_enabled" data-vv-as="hash_enabled" name="hash_enabled">
            </div>
            <div v-if="isLandlord()" class="form__field">
                <label for="is_show_ocupancy" class="form__label">Show ocupancy</label>
                <input style="height: 20px" type="checkbox" v-model.trim="form.is_show_ocupancy" id="is_show_ocupancy" data-vv-as="is_show_ocupancy" name="is_show_ocupancy">
            </div>
            <div v-if="isLandlord()" class="form__field">
                <label for="enable_session_closing" class="form__label">{{ $t('kiosk.enableSessionClosing')}}</label>
                <input style="height: 20px" type="checkbox" v-model.trim="form.enable_session_closing" id="enable_session_closing" data-vv-as="enable_session_closing" name="enable_session_closing">
            </div>
            <div class="form__field">
                <label for="screensaver_enabled" class="form__label">{{ $t('kiosk.enableScreensaver')}}</label>
                <input style="height: 20px" type="checkbox" v-model.trim="form.screensaver_enabled" id="screensaver_enabled" data-vv-as="screensaver_enabled" name="screensaver_enabled">
            </div>
            <div class="form__field">
                <label for="screensaver_show_after" class="form__label">{{ $t('kiosk.screensaverShowAfter')}}</label>
                <input type="number" class="form__input" v-model.trim="form.screensaver_show_after" id="screensaver_show_after" data-vv-as="screensaver_show_after" name="screensaver_show_after"  />
            </div>
            <div class="form__field">
                <label for="qr_code_enabled" class="form__label">{{ $t('kiosk.enableQrCode')}}</label>
                <input style="height: 20px" type="checkbox" v-model.trim="form.qr_code_enabled" id="qr_code_enabled" data-vv-as="qr_code_enabled" name="qr_code_enabled">
            </div>
            <div class="form__field">
                <label for="logo" class="form__label">{{ $t('kiosk.logo')}}</label>
                <input type="text" class="form__input" v-model.trim="form.logo" id="logo" data-vv-as="logo" name="logo"  />
            </div>
            <div class="form__field form__field_textarea" :class="{'form__field_error' : errors.has('logoMeta')}">
                <label for="logoMeta" class="form__label">{{ $t('kiosk.logo_meta')}}</label>
                <textarea type="textarea" class="form__input" v-model.trim="form.logoMeta" v-validate data-vv-rules="validJson" id="logoMeta" name="logoMeta" rows="5"></textarea>
                <tooltip v-show="errors.has('logoMeta')" class="form__validation">{{ $t('errors.invalid_json_format') }}</tooltip>
            </div>
            <div class="form__field form__field_textarea" :class="{'form__field_error' : errors.has('colors')}">
                <label for="colors" class="form__label">{{ $t('kiosk.colors')}}</label>
                <textarea type="textarea" class="form__input" v-model.trim="form.colors" v-validate data-vv-rules="validJson" id="colors" name="colors" rows="5"></textarea>
                <tooltip v-show="errors.has('colors')" class="form__validation">{{ $t('errors.invalid_json_format') }}</tooltip>
            </div>
            <div class="form__field">
                <label for="autloDiscount" class="form__label">{{ $t('kiosk.autloDiscount') }}</label>
                <input type="file" class="form__input" id="autloDiscountUpload" data-vv-as="autloDiscountUpload" name="autloDiscountUpload" accept="image/*" @change="processQrFile($event)"/>
                <button type="button" v-on:click="removeDiscountQr">{{$t('kiosk.removeDiscount')}}</button>
            </div>
            <div class="form__field">
              <label class="form__label">{{ $t('kiosk.currentDiscountQr') }}</label>
              <span>{{form.autloDiscount ? '' : $t('kiosk.noDiscount')}}</span>
              <img style="max-height: 200px" v-bind:src="form.autloDiscount" />
            </div>
            <div class="form__field">
              <label for="langbarPos" class="form__label">{{ $t('kiosk.langbarPos') }}</label>
              <el-select name="langbarPos"
                         v-model="form.langbarPos"
                         placeholder="">
                <el-option
                  :label="$t('kiosk.top')"
                  value="top">
                </el-option>
                <el-option
                  :label="$t('kiosk.bottom')"
                  value="bottom">
                </el-option>
              </el-select>
            </div>
        </fieldset>

        <KioskTicketTypes v-if="kioskId" :kioskId="kioskId" :canEditTypes="isSuperAdmin ? true : kiosk.can_edit_kiosk_permits"/>

        <div class="form__buttons buttonset">
          <router-link :to="{ name: 'tenant', params: { id: tenant.id} }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="submit" class="buttonset__button btn btn--main" v-on:click.prevent.stop="onSubmit()">
            {{ $t('common.save') }}
          </button>
        </div>
      </form>
    </div>

    <KioskPermits v-if="kioskId" :kioskId="kioskId"/>

    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ warningHeader }}</h1>
      <p slot="body">{{ warningBody }}</p>
    </WarningModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import 'styles/blocks/details.scss';
import Autocomplete from 'common/Autocomplete';
import Tooltip from 'common/Tooltip';
import WarningModal from 'common/WarningModal';
import * as mTypes from 'store/mutation-types';
import KioskTicketTypes from "./ticket-types/index";
import KioskPermits from "./kiosk-permits/index"

export default {
  components: {
    Autocomplete,
    Tooltip,
    WarningModal,
    KioskTicketTypes,
    KioskPermits
  },
  computed: {
    isNew() {
      return !this.$route.params.id;
    },
    ...mapGetters({
      products: 'landlord/products/products',
      tenant: 'tenants/tenant/tenant',
      user: 'user/user/user',
      kiosk: 'kiosks/kiosk/kiosk',
      terminals: 'kiosks/terminals/terminals',
      kioskError: 'kiosks/kiosk/error',
    }),
  },
  data() {
    return {
      form: {},
      productId: null,
      warningHeader: null,
      warningBody: null,
      showWarningModal: false,
      kioskId: null
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.fetchKiosk();
    }
    this.fetchTerminals();

  },
  created() {
    this.fetchProducts();
    this.$validator.remove('validJson');
    this.$validator.extend('validJson', {
      getMessage: () => 'Please insert valid json.',
      validate: (value) => {
        try {
          JSON.parse(value);
        } catch (e) {
          return false;
        }
        return true;
      },
    });
  },
  methods: {
    fetchKiosk() {
      this.$store.dispatch('kiosks/kiosk/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
        this.form = this.kiosk;
        this.form.autopay_enabled = this.kiosk.autopay_enabled;
        this.productId = this.kiosk.productId;
        this.kioskId = this.form.id
      });
    },
    fetchTerminals(){
      this.$store.dispatch('kiosks/terminals/fetch').then(() => {
      });
    },
    fetchProducts() {
      if (this.tenant && typeof this.tenant.id !== 'undefined') {
        this.$store.dispatch('landlord/products/fetchTenantProducts', { id: this.tenant.id, user: this.user, type: 'guestParking', limit: 1000 });
      }
    },
    processQrFile(event) {
      const reader = new FileReader();
      reader.addEventListener('load', this.onQrReaderFileLoaded, false);

      if (/image\/.*/.test(event.target.files[0].type)) {
        reader.readAsDataURL(event.target.files[0]);
      }
    },
    onQrReaderFileLoaded(event) {
      this.form.autloDiscount = event.target.result;
    },
    removeDiscountQr() {
      this.form.autloDiscount = '';
    },
    onSubmit() {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) {
            return;
          }
          this.form.productId = this.productId;
          this.form.tenantId = this.tenant.id;
          // this.form.colors = this.form.colors ? JSON.stringify(this.form.colors, null, 2) : null;
          this.$store.dispatch('kiosks/kiosk/add', { kiosk: this.form, user: this.user }).then(() => {
            if (this.kioskError) {
              this.warningHeader = this.$t('common.warning');
              this.warningBody = this.$t(`errors.${this.kioskError}`);
              this.showWarningModal = true;
            } else {
              this.form = {};
              this.$router.push({ name: 'tenant', params: { id: this.tenant.id } });
            }
          }).catch(() => {
            this.$store.commit(`kiosks/kiosk/${mTypes.DATA_ERROR}`, true);
          });
          this.$validator.clean();
          this.$store.commit(`kiosks/kiosk/${mTypes.DATA_ERROR}`, null);
        }).catch(() => {
        });
    },
    closeWarningModal() {
      this.showWarningModal = false;
      this.$store.commit(`kiosks/kiosk/${mTypes.DATA_ERROR}`, null);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tenants/AddKioskView.vue